import { useEffect, useState, useRef } from 'react';
import { Box, Paper } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../actions';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../constants/FirestoreCollections';
import ChatHeader from './ChatHeader';
import ChatInput from './ChatInput';
import MessageBubble from './MessageBubble';

const apiUrl = process.env.REACT_APP_PANEL_URL;
const CustomDFMessengerChat = () => {
  const organization = useSelector((state) => state.app.organization);
  const profile = useSelector((state) => state.firebase.profile);
  const isSupportChatBotOpen = useSelector((state) => state.app.isSupportChatBotOpen);
  const appDispatch = useDispatch();
  const firestore = useFirestore();
  const chatRef = useRef(null);

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const sessionId = `${new Date().toISOString().split('T')[0]}/IASOPORTE/${profile?.email}`;

  useEffect(() => {
    if (isSupportChatBotOpen) {
      const unsubscribe = firestore
        .collection(collections.chats)
        .where('session', '==', sessionId)
        .onSnapshot((snapshot) => {
          if (!snapshot.empty) {
            const chatData = snapshot.docs[0].data();
            setMessages(chatData.messages || []);
          } else {
            const welcomeMessage = getWelcomeMessage(profile.email, organization?.displayName);
            sendMessage({ type: 'text', message: welcomeMessage });
            setMessages([{ type: 2, message: welcomeMessage }]);
          }
        });

      return () => {
        unsubscribe && unsubscribe();
      };
    }
  }, [isSupportChatBotOpen, sessionId, firestore]);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  const getWelcomeMessage = (email, organizationName) => {
    return `Hola! Mi usuario es ${email} y trabajo en la institución ${organizationName}`;
  };
  const sendMessage = async ({ message, type }) => {
    setLoading(true);
    setInput('');

    try {
      const formattedBody = {
        type,
        message,
        session: sessionId,
        profile: {
          email: profile.email,
          organizationName: organization?.displayName,
          organizationId: organization?.id,
        },
      };
      const formData = new FormData();
      formData.append('body', JSON.stringify(formattedBody));
      if (type !== 'text') formData.append('file', message);

      await fetch(`${apiUrl}/ia-chat-message`, {
        method: 'POST',
        body: formData,
      });
    } catch (err) {
      console.error('sendMessage:', err);
    } finally {
      // Meto un timeout por la demora que hay entre peticiones y se recibe la respuesta asi el loading perdura
      await new Promise((resolve) => setTimeout(resolve, 1300));
      setLoading(false);
    }
  };

  const onClose = () => {
    appDispatch({
      type: actions.isSupportChatBotOpen,
      isSupportChatBotOpen: false,
    });
  };

  if (!isSupportChatBotOpen) return null;

  return (
    <Paper
      elevation={2}
      sx={{
        width: '100%',
        maxWidth: '500px',
        height: '100%',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#F3F6FC',
      }}
    >
      <ChatHeader onClose={onClose} />
      <Box
        ref={chatRef}
        sx={{
          flex: 1,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 0.7,
          // Scrollbar styling
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#bfb8b0',
            borderRadius: '8px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#a69f98',
          },
        }}
      >
        {messages.map((msg, index) => (
          <MessageBubble
            key={index}
            message={msg.message}
            type={msg.type}
            email={msg.email}
            contentType={msg.contentType}
          />
        ))}
      </Box>
      <ChatInput input={input} onInputChange={setInput} onSend={sendMessage} loading={loading} />
    </Paper>
  );
};

export default CustomDFMessengerChat;
